import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const widgetSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {
    toggle(state) {
      return { ...state, drawer: !state.drawer };
    },
    set(_, action) {
      return action.payload;
    },
    update(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const widget = widgetSlice.actions;
export default widgetSlice.reducer;
